import { render, staticRenderFns } from "./EternityChallengeBox.vue?vue&type=template&id=a33f7e04&scoped=true&"
import script from "./EternityChallengeBox.vue?vue&type=script&lang=js&"
export * from "./EternityChallengeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33f7e04",
  null
  
)

export default component.exports